import(/* webpackMode: "eager" */ "/app/src/app/public/waitlist/join-waitlist/page.tsx");
